import { render } from "./ResourceAnchor.vue?vue&type=template&id=450f51fc"
import script from "./ResourceAnchor.vue?vue&type=script&lang=ts"
export * from "./ResourceAnchor.vue?vue&type=script&lang=ts"
script.render = render

export default script